import { FC, useEffect, useState } from 'react';
import { Button, message, Modal, Tooltip } from 'antd';
import { taskProps, tenderDataProps } from '../../../pages/TenderViewPage/types';
import {
    useApproveTaskMutation,
    useDeleteFileMutation,
    useDeleteManualySupplierMutation,
    useLazyGetQuestionaryFormQuery
} from '../../../api/tenders';
import { Loader } from '../../Loader/Loader';
import Questionnaire from '../../../assets/Define Phase Questionnaire.svg';
import done from '../../../assets/Done, Check.svg';
import i from '../../../assets/i.svg';
import { AboutQuestionaryModal } from '../../Modals/AboutQuestionaryModal';
import { KikOffQuestionaryModal } from '../../Modals/KikOffQuestionaryModal';
import { WarningTriangle } from '../../Icons/WarningTriangle';
import InfoIcon from '../../Icons/infoIcon';
import { CheckCircle } from '../../Icons/CheckCircle';
import Plus from '../../../assets/Plus, Add.svg';
import { AddSuppInfoModal } from '../../Modals/AddSuppInfoModal';
import { AddSupplierModal } from '../../Modals/AddSupplierModal';
import editAdminIcon from '../../../assets/editAdminIcon.svg';
import Delete from '../../Icons/Delete';
import ManualyAddedSuppliers from '../../../assets/ManualyAddedSuppliers.png';
import PendingCompletionIcon from '../../../assets/PendingCompletionIcon.png';
import ViewQuestionnaire from '../../../assets/ViewQuestionnaire.png';
import './index.scss';

interface DefineQuestionnaireTaskProps {
    data: tenderDataProps;
    role: string | null;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface PrevData {
    link: string;
    comment: string;
}

export const DefineQuestionnaireTask: FC<DefineQuestionnaireTaskProps> = ({ data, role, setTrigger }) => {
    const [isDeleteFileModal, setIsDeleteFileModal] = useState<boolean>(false);

    const [approveTask, { isLoading: isLoadingApprove }] = useApproveTaskMutation();
    const [deleteSuppId, setDeleteSuppId] = useState<number | null>(null);
    const [openAboutQuestionary, setOpenAboutQuestionary] = useState(false);
    const [aboutQuestionnaireVariant, setAboutQuestionnaireVariant] = useState<'define' | 'design'>('define');
    const [openModal, setOpenModal] = useState(false);

    const [openAddSuppInfoModal, setOpenAddSuppInfoModal] = useState(false);
    const [openAddSuppModal, setOpenAddSuppModal] = useState(false);
    const [SupplierData, setSupplierData] = useState<any>(null);
    const [taskId, setTaskId] = useState<number | null>(null);

    const [getForm, { data: formData, isLoading, isFetching }] = useLazyGetQuestionaryFormQuery();

    const [deleteFile, { isLoading: isLoadingDeleteFile }] = useDeleteFileMutation();
    const [deleteSupplier, { isLoading: isLoadingDelete, isSuccess: isSuccessDelete }] =
        useDeleteManualySupplierMutation();

    useEffect(() => {
        if (isSuccessDelete) {
            setTrigger((prev) => !prev);
            setDeleteSuppId(null);
            message.success('Supplier was successfuly deleted');
        }
    }, [isSuccessDelete]);

    const deleteSuppFunc = () => {
        const deleteData = {
            tender_id: data.id,
            invite_id: deleteSuppId
        };

        deleteSupplier(deleteData);
    };

    useEffect(() => {
        if (data) {
            const define_phase_questionnaire_id = data?.phase_tasks?.find(
                (elem) => elem.action === 'define_phase_questionnaire'
            )?.id;
            if (define_phase_questionnaire_id) {
                setTaskId(define_phase_questionnaire_id);
            }
            const design_phase_questionnaire_id = data?.phase_tasks?.find(
                (elem) => elem.action === 'design_phase_questionnaire'
            )?.id;

            if (design_phase_questionnaire_id) {
                setTaskId(design_phase_questionnaire_id);
            }
        }
    }, [data]);

    const approveTaskFunc = async (taskId: number) => {
        try {
            const formData = {
                tenderId: data?.id,
                taskId: taskId
            };
            await approveTask(formData).unwrap();
            await setTrigger((prev: boolean) => !prev);
        } catch {}
    };

    const deleteFileFunc = async () => {
        if (role === 'school_user') {
            try {
                const formData = {
                    tenderId: data.id,
                    taskId: taskId,
                    file: data?.phase_tasks?.find((elem: any) => elem.id === taskId)?.files.school_user[0]?.uuid || null
                };
                await deleteFile(formData).unwrap();
                await setIsDeleteFileModal(false);
                await setTrigger((prev: boolean) => !prev);
            } catch {}
        } else {
            try {
                const formData = {
                    tenderId: data.id,
                    taskId: taskId,
                    file:
                        data?.phase_tasks?.find((elem: any) => elem.id === taskId)?.files.tender_representative[0]
                            ?.uuid || null
                };
                await deleteFile(formData).unwrap();
                await setIsDeleteFileModal(false);
                await setTrigger((prev: boolean) => !prev);
            } catch {}
        }
    };

    const handleStartQuestionary = () => {
        setOpenAboutQuestionary(false);
        setOpenModal(true);
    };

    const getFormData = (step: null | number) => {
        const baseData = {
            tender_id: data.id,
            task_id: taskId,

            step: step
        };

        getForm(baseData);
    };

    const handleOpenQuestionary = (isView: boolean, phase: 'define' | 'design' = 'define') => {
        const baseData = {
            tender_id: data.id,
            task_id: taskId,
            ...(isView && { step: 1 })
        };
        getForm(baseData)
            .unwrap()
            .then(() => {
                setAboutQuestionnaireVariant(phase);
                setOpenAboutQuestionary(true);
            })
            .catch((error) => {
                message.error(error.data.message);
            });
    };

    const SupplierProcced = () => {
        setOpenAddSuppModal(true);
    };

    return (
        <>
            {data?.phase_tasks.length > 0 &&
                data?.phase_tasks.map((elem: taskProps) => {
                    if (elem.action === 'define_phase_questionnaire') {
                        if (role !== 'school_user') {
                            if (elem.status === 'need_approve_tr') {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete ${elem.approved ? 'green' : ''}`}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={Questionnaire} />
                                                {elem?.name}
                                            </div>
                                            {role !== 'super_admin' && (
                                                <div className="task-complete__title-row">
                                                    <div
                                                        className="task-complete__view"
                                                        onClick={() => handleOpenQuestionary(true)}
                                                    >
                                                        <img src={ViewQuestionnaire} />
                                                        View Questionnaire
                                                    </div>

                                                    {elem.approved ? (
                                                        <div className="task__btn-wrap">
                                                            <span className="task__approved-active">
                                                                <img src={done} />
                                                                Approved
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <Tooltip
                                                            overlayClassName={'custom-tooltip-disabled'}
                                                            title={
                                                                elem.can_approve
                                                                    ? ''
                                                                    : 'Please review Kick-off Questionnaire first'
                                                            }
                                                        >
                                                            <div
                                                                className={`task-complete__approved ${
                                                                    elem.can_approve ? '' : 'disabled-blue-button'
                                                                }`}
                                                                onClick={() => {
                                                                    if (isLoadingApprove || !elem.can_approve) return;
                                                                    approveTaskFunc(elem.id);
                                                                }}
                                                            >
                                                                {isLoadingApprove ? <Loader /> : 'Approve'}
                                                            </div>
                                                        </Tooltip>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="task-complete__wrap">
                                            <div
                                                className={`supp-count tr ${
                                                    elem?.suppliers_count <= 5
                                                        ? 'warning'
                                                        : elem?.suppliers_count >= 6 && elem?.suppliers_count <= 9
                                                        ? 'yellow'
                                                        : elem?.suppliers_count >= 10
                                                        ? 'green'
                                                        : ''
                                                }`}
                                            >
                                                <div className="supp-count__wrap">
                                                    <div className="supp-count-title">
                                                        {elem?.suppliers_count <= 5 && (
                                                            <>
                                                                <WarningTriangle /> {elem?.suppliers_count}{' '}
                                                                {elem?.suppliers_count === 1 ? 'supplier' : 'suppliers'}{' '}
                                                                match
                                                            </>
                                                        )}
                                                        {elem?.suppliers_count >= 6 && elem?.suppliers_count <= 9 && (
                                                            <>
                                                                <InfoIcon fill="#E64A0D" /> {elem?.suppliers_count}{' '}
                                                                {elem?.suppliers_count === 1 ? 'supplier' : 'suppliers'}{' '}
                                                                match
                                                            </>
                                                        )}
                                                        {elem?.suppliers_count >= 10 && (
                                                            <>
                                                                <CheckCircle /> More than 10 Suppliers match
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="task-complete__info">
                                                <div className="task__pending" key={elem.id}>
                                                    Service Components:
                                                </div>
                                            </div>
                                            <div className="task-complete__components-wrap">
                                                {elem?.selected_components?.map((com) => {
                                                    return <div className="task-complete__component">{com}</div>;
                                                })}
                                            </div>
                                            {elem?.manually_added_suppliers?.length > 0 && (
                                                <>
                                                    {' '}
                                                    <div className="task-complete__info">
                                                        <div className="task__pending" key={elem.id}>
                                                            Manualy added suppliers:
                                                        </div>
                                                    </div>
                                                    <div className="task-complete__components-wrap">
                                                        {elem?.manually_added_suppliers?.map((supp) => {
                                                            return (
                                                                <div className="manually_added_supplier">
                                                                    <div className="manually_added_supplier__image">
                                                                        <img src={ManualyAddedSuppliers} />
                                                                    </div>
                                                                    <div className="manually_added_supplier__wrap">
                                                                        <div className="manually_added_supplier__name">
                                                                            {supp?.company_name}
                                                                        </div>
                                                                        <div className="manually_added_supplier__email">
                                                                            {supp?.email}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                );
                            }
                        }
                        if (role === 'school_user') {
                            if (elem.status === 'pending_su') {
                                return (
                                    <div key={elem.id} className={`tasks__task task `}>
                                        <div className="task__title">
                                            <div className="task-complete__title-row">
                                                <img src={Questionnaire} />
                                                {elem?.name}
                                            </div>
                                            <div className="task-complete__title-row"></div>
                                        </div>
                                        <div
                                            className="task-complete__btn"
                                            onClick={() => handleOpenQuestionary(false)}
                                        >
                                            {isLoading || isFetching ? (
                                                <Loader color="#001965" />
                                            ) : (
                                                'Open Questionnaire'
                                            )}
                                        </div>
                                    </div>
                                );
                            }
                            if (elem.status === 'completed') {
                                return (
                                    <div key={elem.id} className={`tasks__task-complete task-complete`}>
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={Questionnaire} />
                                                {elem?.name}
                                            </div>

                                            <div className="task-complete__title-row">
                                                <div
                                                    className="task-complete__btn"
                                                    onClick={() => handleOpenQuestionary(false)}
                                                    style={{ margin: '0 12px 0 0' }}
                                                >
                                                    {isLoading || isFetching ? (
                                                        <Loader color="#001965" />
                                                    ) : (
                                                        'Open Questionnaire'
                                                    )}
                                                </div>
                                                <span className="task__approved-active">
                                                    <img src={done} />
                                                    Completed
                                                </span>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="task-complete__info">
                                                <div className="task__pending" key={elem.id}>
                                                    Selected Service Components:
                                                </div>
                                            </div>
                                            <div className="task-complete__components-wrap">
                                                {elem?.selected_components?.map((com) => {
                                                    return <div className="task-complete__component">{com}</div>;
                                                })}
                                            </div>

                                            <div className="task-complete__wrap">
                                                <div
                                                    className={`supp-count ${
                                                        elem?.suppliers_count <= 5
                                                            ? 'warning'
                                                            : elem?.suppliers_count >= 6 && elem?.suppliers_count <= 9
                                                            ? 'yellow'
                                                            : elem?.suppliers_count >= 10
                                                            ? 'green'
                                                            : ''
                                                    }`}
                                                >
                                                    <div className="supp-count__wrap">
                                                        <div className="supp-count-title">
                                                            {elem?.suppliers_count <= 5 && (
                                                                <>
                                                                    <WarningTriangle /> {elem?.suppliers_count}{' '}
                                                                    {elem?.suppliers_count === 1
                                                                        ? 'supplier'
                                                                        : 'suppliers'}{' '}
                                                                    match
                                                                </>
                                                            )}
                                                            {elem?.suppliers_count >= 6 &&
                                                                elem?.suppliers_count <= 9 && (
                                                                    <>
                                                                        <InfoIcon fill="#E64A0D" />{' '}
                                                                        {elem?.suppliers_count}{' '}
                                                                        {elem?.suppliers_count === 1
                                                                            ? 'supplier'
                                                                            : 'suppliers'}{' '}
                                                                        match
                                                                    </>
                                                                )}
                                                            {elem?.suppliers_count >= 10 && (
                                                                <>
                                                                    <CheckCircle /> More than 10 Suppliers match
                                                                </>
                                                            )}
                                                        </div>
                                                        {elem?.suppliers_count <= 5 && (
                                                            <div className="supp-count-subtitle">
                                                                Fewer than {elem?.suppliers_count}{' '}
                                                                {elem?.suppliers_count === 1 ? 'supplier' : 'suppliers'}{' '}
                                                                match your criteria. Consider adjusting your filters to
                                                                include more relevant matches.
                                                            </div>
                                                        )}
                                                        {elem?.suppliers_count >= 6 && elem?.suppliers_count <= 9 && (
                                                            <div className="supp-count-subtitle">
                                                                Your selection matches a moderate number of suppliers.
                                                                You may proceed, or refine your filters to broaden
                                                                participation
                                                            </div>
                                                        )}
                                                        {elem?.suppliers_count >= 10 && (
                                                            <div className="supp-count-subtitle">
                                                                Your selection matches a ideal number of suppliers.
                                                                You're ready to proceed
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div
                                                        className="supp-count__btn"
                                                        onClick={() => {
                                                            setOpenAddSuppInfoModal(true);
                                                        }}
                                                    >
                                                        {' '}
                                                        <img src={Plus} />
                                                        Add Supplier
                                                    </div>
                                                </div>
                                            </div>
                                            {elem?.manually_added_suppliers?.length > 0 && (
                                                <div className="manually_added_supplier__wrapper">
                                                    <div className="task-complete__info">
                                                        <div className="task__pending" key={elem.id}>
                                                            Manualy added suppliers
                                                        </div>
                                                        <div className="note manually_added_supplier-note">
                                                            <img src={i} />
                                                            Invitation(s) will be sent once you have completed all tasks
                                                            in this phase
                                                        </div>
                                                    </div>
                                                    {elem?.manually_added_suppliers?.map((supp) => {
                                                        return (
                                                            <div className="manually_added_supplier">
                                                                <div className="manually_added_supplier__image">
                                                                    <img src={ManualyAddedSuppliers} />
                                                                </div>
                                                                <div className="manually_added_supplier__wrap">
                                                                    <div className="manually_added_supplier__name">
                                                                        {supp?.company_name}
                                                                    </div>
                                                                    <div className="manually_added_supplier__email">
                                                                        {supp?.email}
                                                                    </div>
                                                                </div>
                                                                <div className="manually_added_supplier__btns">
                                                                    <img
                                                                        src={editAdminIcon}
                                                                        onClick={() => {
                                                                            setSupplierData(supp);
                                                                            setOpenAddSuppModal(true);
                                                                        }}
                                                                    />
                                                                    <Delete onClick={() => setDeleteSuppId(supp.id)} />
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            }
                            if (elem.status === 'need_approve_tr') {
                                return (
                                    <div key={elem.id} className={`tasks__task-complete task-complete`}>
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={Questionnaire} />
                                                {elem?.name}
                                            </div>
                                            <div className="task-complete__title-row">
                                                <div
                                                    className="task-complete__view"
                                                    onClick={() => handleOpenQuestionary(true)}
                                                >
                                                    <img src={ViewQuestionnaire} />
                                                    View Questionnaire
                                                </div>

                                                <span className="task__pending">
                                                    <img src={PendingCompletionIcon} className="task__pending-icon" />
                                                    Pending Completion
                                                </span>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="task-complete__info">
                                                <div className="task__pending" key={elem.id}>
                                                    Selected Service Components:
                                                </div>
                                            </div>
                                            <div className="task-complete__components-wrap">
                                                {elem?.selected_components?.map((com) => {
                                                    return <div className="task-complete__component">{com}</div>;
                                                })}
                                            </div>

                                            <div className="task-complete__wrap">
                                                <div
                                                    className={`supp-count ${
                                                        elem?.suppliers_count <= 5
                                                            ? 'warning'
                                                            : elem?.suppliers_count >= 6 && elem?.suppliers_count <= 9
                                                            ? 'yellow'
                                                            : elem?.suppliers_count >= 10
                                                            ? 'green'
                                                            : ''
                                                    }`}
                                                >
                                                    <div className="supp-count__wrap">
                                                        <div className="supp-count-title">
                                                            {elem?.suppliers_count <= 5 && (
                                                                <>
                                                                    <WarningTriangle /> {elem?.suppliers_count}{' '}
                                                                    {elem?.suppliers_count === 1
                                                                        ? 'supplier'
                                                                        : 'suppliers'}{' '}
                                                                    match
                                                                </>
                                                            )}
                                                            {elem?.suppliers_count >= 6 &&
                                                                elem?.suppliers_count <= 9 && (
                                                                    <>
                                                                        <InfoIcon fill="#E64A0D" />{' '}
                                                                        {elem?.suppliers_count}{' '}
                                                                        {elem?.suppliers_count === 1
                                                                            ? 'supplier'
                                                                            : 'suppliers'}{' '}
                                                                        match
                                                                    </>
                                                                )}
                                                            {elem?.suppliers_count >= 10 && (
                                                                <>
                                                                    <CheckCircle /> More than 10 Suppliers match
                                                                </>
                                                            )}
                                                        </div>
                                                        {elem?.suppliers_count <= 5 && (
                                                            <div className="supp-count-subtitle">
                                                                Fewer than {elem?.suppliers_count}{' '}
                                                                {elem?.suppliers_count === 1 ? 'supplier' : 'suppliers'}{' '}
                                                                match your criteria. Consider adjusting your filters to
                                                                include more relevant matches.
                                                            </div>
                                                        )}
                                                        {elem?.suppliers_count >= 6 && elem?.suppliers_count <= 9 && (
                                                            <div className="supp-count-subtitle">
                                                                Your selection matches a moderate number of suppliers.
                                                                You may proceed, or refine your filters to broaden
                                                                participation
                                                            </div>
                                                        )}
                                                        {elem?.suppliers_count >= 10 && (
                                                            <div className="supp-count-subtitle">
                                                                Your selection matches a ideal number of suppliers.
                                                                You're ready to proceed
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {elem?.manually_added_suppliers?.length > 0 && (
                                                <div className="manually_added_supplier__wrapper">
                                                    <div className="task-complete__info">
                                                        <div className="task__pending" key={elem.id}>
                                                            Manualy added suppliers
                                                        </div>
                                                        <div className="note manually_added_supplier-note">
                                                            <img src={i} />
                                                            Invitation(s) will be sent once you have completed all tasks
                                                            in this phase
                                                        </div>
                                                    </div>
                                                    {elem?.manually_added_suppliers?.map((supp) => {
                                                        return (
                                                            <div className="manually_added_supplier">
                                                                <div className="manually_added_supplier__image">
                                                                    <img src={ManualyAddedSuppliers} />
                                                                </div>
                                                                <div className="manually_added_supplier__wrap">
                                                                    <div className="manually_added_supplier__name">
                                                                        {supp?.company_name}
                                                                    </div>
                                                                    <div className="manually_added_supplier__email">
                                                                        {supp?.email}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            }
                        }
                    }
                    if (elem.action === 'design_phase_questionnaire') {
                        if (role === 'school_user') {
                            return (
                                <div
                                    key={elem.id}
                                    className={`tasks__task-complete task-complete ${elem.approved ? 'green' : ''}`}
                                >
                                    <div className="task-complete__title">
                                        <div className="task-complete__title-row">
                                            <img src={Questionnaire} />
                                            {elem?.name}
                                        </div>
                                        <div className="task-complete__title-row">
                                            <div
                                                className="task-complete__view"
                                                onClick={() => handleOpenQuestionary(true, 'design')}
                                            >
                                                <img src={ViewQuestionnaire} />
                                                View full scope
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="task-complete__info">
                                            <div className="task__pending" key={elem.id}>
                                                Service Components:
                                            </div>
                                        </div>
                                        <div className="task-complete__components-wrap">
                                            {elem?.selected_components?.map((com) => {
                                                return <div className="task-complete__component">{com}</div>;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                    }
                })}

            {isDeleteFileModal && (
                <Modal
                    className="confirmModal"
                    centered
                    open={isDeleteFileModal}
                    width={660}
                    closeIcon={<></>}
                    footer={
                        <div
                            style={{
                                display: 'flex',
                                justifyItems: 'space-between',
                                gap: '16px',
                                width: '100%',
                                margin: '25px 0 0 0'
                            }}
                        >
                            <Button key="back" onClick={() => setIsDeleteFileModal(false)} block className="cancel">
                                Cancel
                            </Button>
                            <button className="quit" style={{ width: '100%' }} onClick={deleteFileFunc}>
                                {isLoadingDeleteFile ? <Loader /> : 'Delete'}
                            </button>
                        </div>
                    }
                >
                    <div className="modal-confirm">
                        <div className="modal-confirm__subtitle" style={{ color: '#4D5E93' }}>
                            Are you sure you want to delete the file?
                        </div>
                    </div>
                </Modal>
            )}
            {!!deleteSuppId && (
                <Modal
                    className="confirmModal"
                    centered
                    open={!!deleteSuppId}
                    width={660}
                    closeIcon={<></>}
                    footer={
                        <div
                            style={{
                                display: 'flex',
                                justifyItems: 'space-between',
                                gap: '16px',
                                width: '100%',
                                margin: '25px 0 0 0'
                            }}
                        >
                            <Button key="back" onClick={() => setDeleteSuppId(null)} block className="cancel">
                                Cancel
                            </Button>
                            <button className="quit" style={{ width: '100%' }} onClick={deleteSuppFunc}>
                                {isLoadingDelete ? <Loader /> : 'Delete'}
                            </button>
                        </div>
                    }
                >
                    <div className="modal-confirm">
                        <div className="modal-confirm__subtitle" style={{ color: '#4D5E93' }}>
                            Are you sure you want to delete this supplier?
                        </div>
                    </div>
                </Modal>
            )}
            {openAboutQuestionary && (
                <AboutQuestionaryModal
                    openModal={openAboutQuestionary}
                    setOpenModal={setOpenAboutQuestionary}
                    handleStartQuestionary={handleStartQuestionary}
                    formData={formData}
                    variant={aboutQuestionnaireVariant}
                />
            )}
            {openModal && (
                <KikOffQuestionaryModal
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                    formData={formData}
                    tender_id={data?.id}
                    task_id={taskId}
                    getFormData={getFormData}
                    setTrigger={setTrigger}
                    tenderData={data}
                />
            )}
            {openAddSuppInfoModal && (
                <AddSuppInfoModal
                    openModal={openAddSuppInfoModal}
                    setOpenModal={setOpenAddSuppInfoModal}
                    SupplierProcced={SupplierProcced}
                />
            )}
            <AddSupplierModal
                openModal={openAddSuppModal}
                setOpenModal={setOpenAddSuppModal}
                setTrigger={setTrigger}
                onAfterClose={() => setSupplierData(null)}
                SupplierData={SupplierData}
                data={data}
                setOpenAddSuppInfoModal={setOpenAddSuppInfoModal}
            />
        </>
    );
};
